<template>
  <div
    :class="$style.flexContainer"
  >
    <p
      :class="[$style.statusText, $style[iconColorClass]]"
    >
      {{ statusMessage }}
    </p>
    <Button
      v-if="showRetryLink"
      :class="[$style.retryLink, {[$style.retryLinkDisabled]: isRetryInstalledDisabled}]"
      hasNoBackground
      :isDisabled="isRetryInstalledDisabled"
      isMatchText
      text="Retry"
      @click="handleRetryInstall"
    />
  </div>
</template>

<script>
import { Button } from '@jumpcloud/ui-components';
import { mapActions } from 'vuex';
import { notify } from 'client/util';
import Constants, {
  ItemTypeConsts,
  SoftwareAppStatusConsts,
  StoreModuleMap,
  VppSoftwareAppStatusConsts,
} from 'client/util/Constants';
import SoftwareAppsStatusUtil from 'client/util/SoftwareAppsStatusUtil';
import SystemMixin from 'client/store/mixins/SystemMixin';

const softwareAppsStatusCollection = StoreModuleMap[ItemTypeConsts.softwareAppsStatus];

const { error, success } = Constants;

export default {
  name: 'SoftwareAppsStatusLabel',

  components: {
    Button,
  },

  props: {
    inDevicesAside: {
      type: Boolean,
      default: false,
    },
    isAppleVpp: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    iconColorClass: '',
    statusMessage: '',
    isRetryInstalledDisabled: false,
  }),

  computed: {
    isIOS() {
      return SystemMixin.isIOS(this.system);
    },

    isMacOS() {
      return SystemMixin.isMacOS(this.system);
    },

    showRetryLink() {
      const { state } = this.item.status || this.item;
      const fullStatus = state || '';
      const isNotAllowedForRetry = SoftwareAppsStatusUtil
        .notAllowedForRetry({ fullStatus, isAppleVpp: this.isAppleVpp });

      return ((this.isMacOS || this.isIOS) && !this.inDevicesAside)
      && !isNotAllowedForRetry;
    },

    system() {
      return this.item.device || this.item;
    },
  },

  mounted() {
    if (this.isMacOS || this.isIOS || this.inDevicesAside) {
      this.getVppSoftwareAppsStatusIcon();
    } else {
      this.getSoftwareAppsStatusIcon();
    }
  },

  methods: {
    ...mapActions(softwareAppsStatusCollection, [
      'retryInstall',
    ]),

    getSoftwareAppsStatusIcon() {
      const { state } = this.item.status || this.item;
      const fullStatus = state || '';
      const statusIndex = fullStatus.indexOf('_') + 1;
      const statusType = fullStatus.substring(statusIndex);
      if (SoftwareAppStatusConsts[statusType]) {
        this.iconColorClass = SoftwareAppStatusConsts[statusType].iconColorClass;
        this.statusMessage = fullStatus.replace('_', ' ');
      } else {
        this.iconColorClass = SoftwareAppStatusConsts.PENDING.iconColorClass;
        this.statusMessage = fullStatus;
      }
    },

    getVppSoftwareAppsStatusIcon() {
      const { state } = this.item.status || this.item;
      const fullStatus = state || '';

      if (VppSoftwareAppStatusConsts[fullStatus]) {
        this.iconColorClass = VppSoftwareAppStatusConsts[fullStatus].iconColorClass;
        this.statusMessage = VppSoftwareAppStatusConsts[fullStatus].value;
      } else {
        this.iconColorClass = VppSoftwareAppStatusConsts.PENDING.iconColorClass;
        this.statusMessage = fullStatus;
      }
    },

    async handleRetryInstall() {
      this.isRetryInstalledDisabled = true;
      try {
        await this.retryInstall({ systemId: this.system.id });
        notify(success, 'Command successfully sent.');
      } catch {
        notify(error, 'An error occurred, and the command could not be sent.');
      }
    },

  },
};
</script>

<style module>
@import '../../../css/tooltips.css';

@value (
  jcGrey100,
  jcGrey400,
  jcInformationalBase,
  jcSuccess100,
  jcWarning100,
  jcError100
) from '~css/brand-colors.css';

.active {
  background-color: jcSuccess100;
}

.critical {
  background-color: jcError100;
}

.flexContainer {
  display: flex;
}

.informational {
  background-color: jcGrey100;
}

.pending {
  background-color: jcWarning100;
}

.retryLink {
  color: jcInformationalBase !important;
  flex: 0 0 5rem;
}

.retryLinkDisabled {
  color: jcGrey400 !important;
}

.statusText {
  border-radius: 5px;
  display: inline-block;
  flex: 0 0 10rem;
  font-size: 11px;
  margin-bottom: 0 !important;
  margin-top: 2px;
  padding: 1px 5px;
  text-align: center;
}

@media (max-width: 1500px) {
  .flexContainer {
    flex-direction: column;
  }

  .retryLink {
    flex: 0 0 2rem;
  }

  .statusText {
    flex: 0 0 1rem;
  }
}
</style>
